module.exports = __webpack_public_path__ + "mobile_app_chatroc360_qr_code_android.3d92647.png";